<template>
  <div class="bundle-customiser">
    <BundleCustomiserTriggerMetafields
      v-for="(collection, index) in bundle.collections"
      :key="collection.handle"
      :collection="collection"
      :is-collection-bundle="isCollectionBundle"
      :index="index"
    />
    <template v-if="isCollectionBundle">
      <BundleCustomiserTriggerMetafields
        v-for="(option, index) in bundleOptions"
        :key="`collection-${index}`"
        :collection="option"
        :is-collection-bundle="isCollectionBundle"
        :index="index"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useBundleStore } from '../pinia/BundleStore'

import BundleCustomiserTriggerMetafields from './bundle-customiser-trigger-metafields'

export default {
  components: {
    BundleCustomiserTriggerMetafields
  },
  computed: {
    ...mapState (useBundleStore, [
      'bundle',
      'bundleOptions',
      'isCollectionBundle',
      'isDuo',
      'isTrio'
    ])
  },
}
</script>
